var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSportsShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.892,
    x2: 447.592,
    y1: 192.8,
    y2: 418.907
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff637b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e63950"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c50000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c50000"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.999,
    x2: 254.999,
    xlinkHref: "#lg1",
    y1: 470.509,
    y2: 557.782
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 2.443,
    y2: 47.194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b5dbff"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5e8fe"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.672,
    x2: 301.263,
    xlinkHref: "#lg2",
    y1: -10.917,
    y2: 87.736
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.172,
    x2: 128.018,
    xlinkHref: "#lg2",
    y1: 149.608,
    y2: 149.608
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 1 787.968 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 345.14,
    x2: 405.986,
    xlinkHref: "#lg2",
    y1: 149.608,
    y2: 149.608
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.28,
    x2: 23.42,
    xlinkHref: "#lg1",
    y1: 398.302,
    y2: 132.733
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.239,
    x2: 153.049,
    xlinkHref: "#lg1",
    y1: 372.473,
    y2: 241.538
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.889,
    x2: 256.049,
    xlinkHref: "#lg2",
    y1: 241.124,
    y2: 380.668
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.59,
    x2: 327.75,
    xlinkHref: "#lg2",
    y1: 218.434,
    y2: 357.977
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.661 140.014c0-42.684 10.989-81.315 28.744-109.24-25.893-10.506-53.8-16.071-82.285-16.071h-170.242c-28.485 0-56.392 5.565-82.284 16.07 17.756 27.925 28.745 66.556 28.745 109.24 0 49.046-14.51 92.741-37.123 120.99v229.205c0 10.931 8.861 19.792 19.791 19.792h311.984c10.931 0 19.792-8.861 19.792-19.792v-229.206c-22.612-28.248-37.122-71.943-37.122-120.988z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.216 389.184v101.024c0 10.931 8.861 19.792 19.791 19.792h311.985c10.931 0 19.791-8.861 19.791-19.792v-101.024z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.227 10.852c-47.741-14.469-98.713-14.469-146.453 0-8.499 2.576-12.791 11.98-9.246 20.122 14.189 32.596 45.778 55.278 82.472 55.278s68.283-22.682 82.473-55.278c3.545-8.142-.748-17.546-9.246-20.122z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.79 10.171c-7.485-3.599-16.516-.096-19.472 7.665-8.512 22.351-22.25 44.187-57.318 44.187s-48.806-21.836-57.318-44.187c-2.956-7.761-11.987-11.264-19.472-7.665l-3.993 1.92c-5.883 2.829-8.66 9.651-6.451 15.794 12.855 35.743 47.065 61.295 87.234 61.295s74.379-25.553 87.234-61.296c2.209-6.143-.568-12.965-6.451-15.794z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m128.018 140.014c0-43.682-10.02-83.119-26.119-111.18-2.742-4.779-8.532-6.875-13.685-4.926l-.351.133c-6.306 2.385-9.141 9.794-5.916 15.715 13.11 24.076 21.435 60.054 21.435 100.258 0 51.289-13.548 95.7-33.295 117.297-2.038 2.229-3.078 5.188-2.894 8.203.602 9.859 12.733 14.143 19.422 6.876 24.802-26.948 41.403-76.146 41.403-132.376z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.982 140.014c0-43.682 10.02-83.119 26.119-111.18 2.742-4.779 8.532-6.875 13.685-4.926l.351.133c6.306 2.385 9.141 9.794 5.916 15.715-13.11 24.076-21.435 60.054-21.435 100.258 0 51.289 13.548 95.7 33.295 117.297 2.038 2.229 3.078 5.188 2.894 8.203-.602 9.859-12.733 14.143-19.422 6.876-24.802-26.948-41.403-76.146-41.403-132.376z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m430.783 490.208v-97.817l-182.667-182.667c-2.187-5.8-10.08-8.164-17.064-8.164-2.816 0-5.378.512-7.426 1.792l-33.805 20.489c-5.122 3.073-6.249 7.018-6.249 12.395 0 6.526 2.288 13.043 7.647 15.158 1.536 3.188 17.238 18.686 18.732 19.992v104.424c0 4.5 1.842 7.756 6.211 9.786l124.403 124.404h70.426c10.931 0 19.792-8.861 19.792-19.792z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.998 209.724c-2.187-5.8-10.08-8.164-17.064-8.164-2.816 0-5.378.512-7.426 1.792l-33.805 20.489c-5.122 3.073-6.249 7.018-6.249 12.395 0 6.526 2.288 13.043 7.647 15.158 1.536 3.188 17.238 18.686 18.732 19.992v104.424c0 4.5 1.842 7.756 6.211 9.786l123.063 123.064c7.41-2.86 12.676-10.033 12.676-18.452v-176.699z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m208.773 245.455-7.427 4.611c-2.305 1.536-4.611 2.048-6.402 2.048-7.427 0-12.549-7.939-12.549-15.877 0-5.378 2.305-10.5 7.427-13.573l33.805-20.489c2.048-1.28 4.609-1.792 7.426-1.792 8.195 0 17.672 4.865 17.672 12.549v162.878c0 8.195-9.988 12.294-19.976 12.294s-19.975-4.099-19.975-12.294v-130.355z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m287.654 245.455-7.427 4.611c-2.305 1.536-4.611 2.048-6.402 2.048-7.427 0-12.549-7.939-12.549-15.877 0-5.378 2.305-10.5 7.427-13.573l33.805-20.489c2.048-1.28 4.609-1.792 7.426-1.792 8.195 0 17.672 4.865 17.672 12.549v162.878c0 8.195-9.988 12.294-19.976 12.294s-19.975-4.099-19.975-12.294v-130.355z",
    fill: "url(#SVGID_10_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSportsShirt);
export default __webpack_public_path__ + "static/media/icon-sports-shirt.1b577b39ba5f430fa0dde50abeba3bac.svg";
export { ForwardRef as ReactComponent };